import React from 'react';
import {ILocaleContext} from '../@interfaces/contexts/ILocaleContext';

export const LocaleContext = React.createContext<ILocaleContext>({locale: 'en', fallbackLocale: 'en'});
